<!--
 * @Description:批量分发
 * @Author: JDY
 * @Date: 2021-04-25 14:20:09
 * @LastEditTime: 2021-06-28 16:32:55
 * @LastEditors: JDY
-->
<template>
  <a-form :form="form">
    <a-form-item label="分发类型" :labelCol="labelCol" :wrapperCol="wrapperCol">
      <a-radio-group
        name="type"
        v-decorator="[
          'type',
          {
            rules: [{ required: true, message: '请选择分发类型' }],
            initialValue: '1'
          }
        ]"
        @change="handleChange"
      >
        <a-radio-button value="1">
          站内
        </a-radio-button>
        <a-radio-button value="2">
          站外
        </a-radio-button>
      </a-radio-group>
    </a-form-item>

    <a-form-item label="选择用户" :labelCol="labelCol" :wrapperCol="wrapperCol" v-if="selectKey === (1).toString()">
      <a-spin :spinning="selectLoad">
        <a-select
          mode="multiple"
          optionFilterProp="children"
          name="member"
          showArrow
          allow-clear
          placeholder="请输入要搜索的用户"
          @search="getSearch"
          v-decorator="[
            'member',
            {
              rules: [{ required: true, message: '请选择分发用户' }]
            }
          ]"
        >
          <a-select-option v-for="item in userList" :key="item.id.toString()">
            <template v-if="item.phone"> {{ item.phone }}-</template
            ><template v-if="item.real_name"> {{ item.real_name }}-</template>
            <template v-if="item.email"> {{ item.email }}</template>
          </a-select-option>
        </a-select>
      </a-spin>
    </a-form-item>

    <template v-if="selectKey === (2).toString()">
      <a-form-item label="是否限定使用" :labelCol="labelCol" :wrapperCol="wrapperCol">
        <a-radio-group
          name="restrict"
          v-decorator="[
            'restrict',
            {
              rules: [{ required: true, message: '是否限定使用' }],
              initialValue: 2
            }
          ]"
        >
          <a-radio :value="1">
            是
          </a-radio>
          <a-radio :value="2">
            否
          </a-radio>
        </a-radio-group>
      </a-form-item>
      <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol" help="多个邮箱请换行输入">
        <a-textarea
          type="text"
          :auto-size="{ minRows: 3, maxRows: 10 }"
          placeholder="请输入邮箱"
          v-decorator="[
            'email',
            {
              rules: [{ required: true, message: '请输入邮箱地址' }],
              validateTrigger: ['change', 'blur']
            }
          ]"
        />
      </a-form-item>
    </template>
  </a-form>
</template>

<script>
import { requestGet, requestPut } from '@/api/api'

export default {
    name: 'ModelForm',
    props: {
        tid: {
            type: Array,
            default: () => {
                return []
            },
            required: true
        }
    },
    data () {
        return {
            selectLoad: false, // 加载
            labelCol: {
                xs: { span: 24 },
                sm: { span: 7 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 13 }
            },
            userList: null,
            selectKey: '1',
            params: {},
            form: this.$form.createForm(this)
        }
    },
    mounted () {
        this.getUserList() // 获取用户位列
    },
    methods: {
        handleChange (selectKey) {
            this.selectKey = selectKey.target.value
        },
        splitArray (arr, len) {
            const newArr = []
            for (let i = 0; i < arr.length; i += len) {
                newArr.push(arr.slice(i, i + len))
            }
            return newArr
        },
        /**
         * 获取用户下拉列表
         * @param
         * @jdy
         */
        getSearch (value) {
            const { params } = this
            if (value.length > 2) {
                params.member = value
                setTimeout(() => {
                    this.getUserList()
                }, 300)
            }
        },
        /**
         * 获取用户下拉列表
         * @param
         * @jdy
         */
        getUserList () {
            const { params } = this
            requestGet('/members/select', params)
                .then(res => {
                    this.userList = res.result
                })
                .catch(err => {
                    this.$notification.error(err)
                })
        },
        /**
         * 点击确定按钮提交表单
         * @param
         * @jdy
         */
        onOk () {
            const that = this
            const {
                form: { validateFields }
            } = that
            return new Promise(resolve => {
                // 回调resolve(true)关闭弹出层
                validateFields((errors, values) => {
                    values.id = that.$props.tid
                    if (!errors) {
                        requestPut('/coupons/distribute', values)
                            .then(res => {
                                that.$notification.success({
                                    message: res.msg
                                })
                                resolve(true) // 关闭弹出层
                            })
                            .catch(err => console.log(err))
                    }
                })
            })
        },
        /**
         * 去掉按钮关闭弹窗
         * @param
         * @jdy
         */
        onCancel () {
            return new Promise(resolve => {
                resolve(true)
            })
        }
    }
}
</script>
